/* The bounds of a wait the slideshow will run, read by the block that judges
   the authored field and by the shell that runs the timer. ⚠ A PLAIN MODULE:
   neither half can import constants from the other across the client boundary. */

/** The row's glide from one title to the next, in seconds: the stylesheet's
 *  `--duration-slow`, which the spec holds this to. A shorter wait brings the
 *  next title in before the last one has arrived. */
export const GLIDE_SECONDS = 0.3;

/** The longest wait a browser timer holds. Past it `setInterval` overflows and
 *  fires about every millisecond, which is a flicker rather than a slideshow. */
export const LONGEST_WAIT_SECONDS = (2 ** 31 - 1) / 1000;

/** A day, in seconds — turns the longest wait into days for the diagnostics
 *  that report it. */
export const DAY_SECONDS = 24 * 60 * 60;
